export const APP_LOAD = "APP_LOAD";
export const REDIRECT = "REDIRECT";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const REQUIRE_AUTH = "REQUIRE_AUTH";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const MESSAGE_SENDED = "MESSAGE_SENDED";
export const MESSAGE_CLOSED = "MESSAGE_CLOSED";

export const NEW_CLIENT_SUBMITED = "NEW_CLIENT_SUBMITED";
export const CLIENT_FORM_TOGGLE = "CLIENT_FORM_TOGGLE";
export const SET_VISIT_DATE = "SET_VISIT_DATE";

export const USER_UPDATE = "USER_UPDATE";
export const USERS_LOADED = "USERS_LOADED";

export const CLIENTS_LOADED = "CLIENTS_LOADED";

export const UPDATE_SINGLE_CLIENT = "UPDATE_SINGLE_CLIENT";
export const UPDATE_SINGLE_CONTRACT = "UPDATE_SINGLE_CONTRACT";

export const CLIENT_STATUS_CHANGED = "CLIENT_STATUS_CHANGED";
export const CLIENT_LOADED = "CLIENT_LOADED";
export const CONTRACT_SIGNED = "CONTRACT_SIGNED";
export const CONTRACT_UPDATED = "CONTRACT_UPDATED";
export const CONTRACT_CLOSED = "CONTRACT_CLOSED";
export const MANAGERS_LOADED = "MANAGERS_LOADED";
export const DUPLICATE_CLIENT = "DUPLICATE_CLIENT";

export const CONTRACT_STEP_CHANGE = "CONTRACT_STEP_CHANGE";

export const UPLOAD_PROGRESS = "UPLOAD_PROGRESS";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js